import { FunctionComponent } from 'react';
import { Box, Grid } from '@mui/material';

import useMobileDetect from '../../../hooks/useMobileDetect';

import {
  BackButton,
  NavigationButtons,
  SaveAndExitButton,
  StandaloneButton,
} from './buttons';

interface ModalButtonsProps {
  disabled?: boolean;
  loadingContinue?: boolean;
  loadingSaveAndExit?: boolean;
  loadingStandalone?: boolean;
  onBack?: () => void;
  onContinue?: () => void;
  onSaveAndExit?: () => void;
  onStandaloneClick?: () => void;
  showBack?: boolean;
  showContinue?: boolean;
  showSaveAndExit?: boolean;
  standalone?: boolean;
  standaloneText?: string;
}

const ProfilePopUpButtons: FunctionComponent<ModalButtonsProps> = ({
  disabled = false,
  loadingContinue = false,
  loadingSaveAndExit = false,
  loadingStandalone = false,
  onBack,
  onContinue,
  onSaveAndExit,
  onStandaloneClick,
  showBack = false,
  showContinue = true,
  showSaveAndExit = false,
  standalone = false,
  standaloneText = 'Continue',
}) => {
  const isMobile = useMobileDetect();

  return (
    <Grid container item xs={12}>
      {
        standalone
          ? (
            <>
              <StandaloneButton
                disabled={disabled}
                fullWidth={isMobile}
                loading={loadingStandalone}
                onClick={onStandaloneClick}
                text={standaloneText}
              />
              {
                showBack && showSaveAndExit && (
                  <Grid
                    container
                    direction='row'
                    justifyContent='space-between'
                    mt={5}
                  >
                    <Grid container item justifyContent='flex-start' xs={6}>
                      <BackButton onClick={onBack} />
                    </Grid>
                    <Grid container item justifyContent='flex-end' xs={6}>
                      <SaveAndExitButton
                        loading={loadingSaveAndExit}
                        onClick={onSaveAndExit}
                      />
                    </Grid>
                  </Grid>
                )
              }
            </>
          )
          : (
            <>
              <NavigationButtons
                disabled={disabled}
                isMobile={isMobile}
                loadingContinue={loadingContinue}
                onBackClick={onBack}
                onContinue={onContinue}
                showBack={showBack}
                showContinue={showContinue}
              />
              {
                showSaveAndExit && (
                  <Box display='flex' justifyContent='center' mt={2} width='100%'>
                    <SaveAndExitButton
                      loading={loadingSaveAndExit}
                      onClick={onSaveAndExit}
                    />
                  </Box>
                )
              }
            </>
          )
      }
    </Grid>
  );
};

export default ProfilePopUpButtons;
